import { createContext, useContext, useState, useEffect } from "react";
import { getRouteLinkIndexAdmin } from "../Functions/RouterFunction";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [state, setState] = useState(() => {
    const routerLink = getRouteLinkIndexAdmin();
    const storedToken = localStorage.getItem("authToken");
    const storedCompanyId = localStorage.getItem("companyId");
    const isDesktop = typeof window !== "undefined" ? window.innerWidth >= 1024 : true;

    return {
      loader: false,
      sideBar: isDesktop,
      authToken: storedToken || false,
      companyId: storedCompanyId,
      companyData: false,
      dashboardData: false,
      pageName: routerLink?.title || "Dashboard",
      pageLink: routerLink?.link || "/dashboard",
      queries: null,
    };
  });
  const dispatch = (updates) => {
    setState((prevState) => {
      const newState = { ...prevState, ...updates };
      if (Object.prototype.hasOwnProperty.call(updates, "authToken")) {
        if (updates.authToken) {
          localStorage.setItem("authToken", updates.authToken);
        } else {
          localStorage.removeItem("authToken");
        }
      }
      if (Object.prototype.hasOwnProperty.call(updates, "companyId")) {
        if (updates.companyId) {
          localStorage.setItem("companyId", JSON.stringify(updates.companyId));
        } else {
          localStorage.removeItem("companyId");
        }
      }
      return newState;
    });
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        dispatch({ sideBar: false });
      } else {
        dispatch({ sideBar: true });
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  }
  return context;
};